import {
  adminOrdersFail,
  adminOrdersRequest,
  adminOrdersSuccess,
  createOrderFail,
  createOrderRequest,
  createOrderSuccess,
  deleteOrderFail,
  deleteOrderRequest,
  deleteOrderSuccess,
  getSellerOrderFail,
  getSellerOrderRequest,
  getSellerOrderSuccess,
  getSellerSingleOrderFail,
  getSellerSingleOrderRequest,
  getSellerSingleOrderSuccess,
  getShippingCostFail,
  getShippingCostRequest,
  getShippingCostSuccess,
  orderDetailFail,
  orderDetailRequest,
  orderDetailSuccess,
  updateOrderFail,
  updateOrderRequest,
  updateOrderSuccess,
  userOrdersFail,
  userOrdersRequest,
  userOrdersSuccess,
} from "../slices/orderSlice";
import axios from "axios";
import { toast } from "react-toastify";

export const createOrder = (order) => async (dispatch) => {
  try {
    dispatch(createOrderRequest());
    const { data } = await axios.post(`/api/v1/order/new`, order);
    dispatch(createOrderSuccess(data));
  } catch (error) {
    dispatch(createOrderFail(error.response.data.message));
  }
};
export const userOrders = async (dispatch) => {
  try {
    dispatch(userOrdersRequest());
    const { data } = await axios.get(`/api/v1/myorders`);
    dispatch(userOrdersSuccess(data));
  } catch (error) {
    dispatch(userOrdersFail(error.response.data.message));
  }
};
export const orderDetail = (id) => async (dispatch) => {
  try {
    dispatch(orderDetailRequest());
    const { data } = await axios.get(`/api/v1/order/${id}`);
    dispatch(orderDetailSuccess(data));
  } catch (error) {
    dispatch(orderDetailFail(error.response.data.message));
  }
};

export const adminOrders =
  (keyword, OrderStatus, currentPage) => async (dispatch) => {
    try {
      dispatch(adminOrdersRequest());
      let link = `/api/v1/admin/orders?page=${currentPage}`;
      if (keyword) link += `&keyword=${keyword}`;
      if (OrderStatus) link += `&orderStatus=${OrderStatus}`;

      const { data } = await axios.get(link);
      dispatch(adminOrdersSuccess(data));
    } catch (error) {
      dispatch(adminOrdersFail(error.response.data.message));
    }
  };

export const deleteOrder = (id) => async (dispatch) => {
  try {
    dispatch(deleteOrderRequest());
    await axios.delete(`/api/v1/admin/order/${id}`);
    dispatch(deleteOrderSuccess());
  } catch (error) {
    dispatch(deleteOrderFail(error.response.data.message));
  }
};

export const updateOrder = (id, orderData) => async (dispatch) => {
  try {
    dispatch(updateOrderRequest());
    const { data } = await axios.put(`/api/v1/admin/order/${id}`, orderData);
    dispatch(updateOrderSuccess(data));
  } catch (error) {
    dispatch(updateOrderFail(error.response.data.message));
  }
};

export const getSellerOrders =
  (keyword, OrderStatus, currentPage) => async (dispatch) => {
    try {
      dispatch(getSellerOrderRequest());
      let link = `/api/v1/seller/orders?page=${currentPage}`;
      if (keyword) link += `&keyword=${keyword}`;
      if (OrderStatus) link += `&orderStatus=${OrderStatus}`;
      const { data } = await axios.get(link);
      dispatch(getSellerOrderSuccess(data));
    } catch (error) {
      dispatch(getSellerOrderFail(error.response.data.message));
    }
  };

export const getSellerSingleOrder = (id) => async (dispatch) => {
  try {
    dispatch(getSellerSingleOrderRequest());
    const { data } = await axios.get(`/api/v1/seller/order/${id}`);
    dispatch(getSellerSingleOrderSuccess(data));
  } catch (error) {
    dispatch(getSellerSingleOrderFail(error.response.data.message));
  }
};

export const getShippingCost = (cartItem, shippingInfo) => async (dispatch) => {
  try {
    dispatch(getShippingCostRequest());

    const { data } = await axios.post(`/api/v1/calculateshipping`, {
      cartItem,
      shippingInfo,
    });

    dispatch(getShippingCostSuccess(data));
  } catch (error) {
    dispatch(getShippingCostFail(error.response.data.message));
  }
};

export const requestInvoice = (id) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };

    const { data } = await axios.post(
      `/api/v1/request-invoice/${id}`,
      {},
      config
    );

    toast.success(
      "Invoice request email sent to support@glocre.com"
    );

  } catch (error) {
    toast.error(
      error.response?.data?.message || "Something went wrong"
    );
  }
};